import type { PaymentMethod } from 'src/game/iap/iap.types';
import { duration } from '../utils/duration';

export type DayStatsConfig = {
  // The time offset in ms of the day stats, we store it in UTC but you may want to use specific timezone for day stats
  timeOffsetMs: number;
  // The initial value of the day stats
  initial: number;
};

export type StatsID = PersistentStats | SessionStats;

// Define stats IDs here
export type PersistentStats =
  | 'puzzleAttempts'
  | 'currentPuzzleAttempts'
  | 'webPaySequence'
  | 'webPayPurchaseSequence'
  | `${PaymentMethod}_sequence`
  | 'icebreakerAbsoluteSequence'
  | 'icebreakerAbsoluteGreetingSequence'
  | 'icebreakerAbsoluteBotInviteSequence';

export type SessionStats =
  | 'puzzleAttempts'
  | 'currentPuzzleAttempts'
  | 'webPaySequence'
  | 'webPayPurchaseSequence'
  | `${PaymentMethod}_sequence`;

export type DayStats =
  | 'icebreakerDaySequence'
  | 'icebreakerDayGreetingSequence'
  | 'icebreakerDayBotInviteSequence';

export const initialPersistentStats: Record<PersistentStats, number> = {
  puzzleAttempts: 1,
  currentPuzzleAttempts: 0,
  webPaySequence: 0,
  webPayPurchaseSequence: 0,

  apple_native_sequence: 0,
  stripe_applePay_sequence: 0,
  stripe_googlePay_sequence: 0,
  komoju_credit_card_sequence: 0,
  komoju_au_sequence: 0,
  komoju_aupay_sequence: 0,
  komoju_docomo_sequence: 0,
  komoju_softbank_sequence: 0,
  komoju_paidy_sequence: 0,
  komoju_rakutenpay_sequence: 0,
  komoju_paypay_sequence: 0,
  komoju_merpay_sequence: 0,
  atone_lite_sequence: 0,
  atone_bnpl_sequence: 0,
  google_native_sequence: 0,

  // Icebreaker stats
  icebreakerAbsoluteSequence: 0,
  icebreakerAbsoluteGreetingSequence: 0,
  icebreakerAbsoluteBotInviteSequence: 0,
};

export const initialSessionStats: Record<SessionStats, number> = {
  puzzleAttempts: 1,
  currentPuzzleAttempts: 0,
  webPaySequence: 0,
  webPayPurchaseSequence: 0,

  stripe_applePay_sequence: 0,
  stripe_googlePay_sequence: 0,
  komoju_credit_card_sequence: 0,
  komoju_au_sequence: 0,
  komoju_aupay_sequence: 0,
  komoju_docomo_sequence: 0,
  komoju_softbank_sequence: 0,
  komoju_paidy_sequence: 0,
  komoju_rakutenpay_sequence: 0,
  komoju_paypay_sequence: 0,
  komoju_merpay_sequence: 0,
  atone_lite_sequence: 0,
  atone_bnpl_sequence: 0,
  apple_native_sequence: 0,
  google_native_sequence: 0,
};

export const initialDayStats: Record<DayStats, DayStatsConfig> = {
  // Count of messages with IcebreakerMessageSuccess event sent in the day
  icebreakerDaySequence: {
    timeOffsetMs: duration({ hours: 9 }), // JST offset
    initial: 0,
  },
  // Count of messages with IcebreakerMessageSuccess of the same Greeting feature sent in the day
  icebreakerDayGreetingSequence: {
    timeOffsetMs: duration({ hours: 9 }), // JST offset
    initial: 0,
  },
  // Count of messages with IcebreakerMessageSuccess of the same Bot invite feature sent in the day
  icebreakerDayBotInviteSequence: {
    timeOffsetMs: duration({ hours: 9 }), // JST offset
    initial: 0,
  },
};
